import * as React from 'react';
export const IcCapsLock = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.16 13.2c-.06-.16-.08-.36-.16-.36s-.1.2-.16.36l-.83 2.51c-.03.09-.03.14-.03.16 0 .05.03.07.1.07h1.83c.07 0 .1-.02.1-.07 0-.02 0-.07-.03-.16l-.82-2.51z'
      fill='currentColor'
    />
    <path
      d='M18.75 9.29c-.32-.55-.77-1-1.32-1.32v-.51c0-1.45-.57-2.83-1.59-3.86A5.436 5.436 0 0012 2c-1.44 0-2.82.57-3.84 1.6a5.456 5.456 0 00-1.59 3.86v.51a3.632 3.632 0 00-1.81 3.13v7.27c0 .96.38 1.89 1.06 2.57.68.68 1.6 1.07 2.56 1.07h7.25c.96 0 1.88-.38 2.56-1.07.68-.68 1.06-1.61 1.06-2.57V11.1c0-.63-.17-1.26-.49-1.81h-.01zm-8.04-3.12a1.809 1.809 0 013.09 1.29h-3.62c0-.48.19-.94.53-1.29zM14.59 19c-.25 0-.52-.11-.64-.48l-.35-.99c-.03-.1-.08-.16-.17-.16h-2.87c-.09 0-.14.06-.17.16l-.35.99c-.13.36-.39.48-.64.48-.36 0-.79-.23-.79-.65 0-.09.02-.2.07-.32l2.19-6c.29-.8.54-1.03 1.14-1.03.6 0 .85.24 1.13 1.03l2.19 6c.05.11.07.23.07.32 0 .39-.4.65-.79.65h-.02z'
      fill='currentColor'
    />
  </svg>
);
